// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"81afadc7","267":"6c7cd504","287":"c02ba2d8","295":"6f73f425","411":"67fd05c3","453":"78ec0c29","729":"198d27f2","825":"0412b4f4"}[chunkId] + ".chunk.js";
};